import * as React from "react";
const SvgLabel = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.03 5 3 5.01v13.98l14.03.01L22 12l-4.97-7z",
  fill: "currentColor"
}));
export default SvgLabel;